import Chromosome from '../Chromosome';

const SCAFFOLDS = [
    new Chromosome("chrUn_KN149696v1", 368637),
    new Chromosome("chrUn_KN149690v1", 343018),
    new Chromosome("chrUn_KN150474v1", 312116),
    new Chromosome("chrUn_KN150681v1", 279222),
    new Chromosome("chrUn_KN150460v1", 266772),
    new Chromosome("chrUn_KN149686v1", 260365),
    new Chromosome("chrUn_KN149688v1", 252705),
    new Chromosome("chrUn_KN149691v1", 233193),
    new Chromosome("chrUn_KN150702v1", 212296),
    new Chromosome("chrUn_KN149689v1", 196689),
    new Chromosome("chrUn_KN149695v1", 190731),
    new Chromosome("chrUn_KN150691v1", 184625),
    new Chromosome("chrUn_KN149687v1", 165668),
    new Chromosome("chrUn_KN149685v1", 164780),
    new Chromosome("chrUn_KN150214v1", 162877),
    new Chromosome("chrUn_KN149694v1", 162759),
    new Chromosome("chrUn_KN149684v1", 159057),
    new Chromosome("chrUn_KN149683v1", 152860),
    new Chromosome("chrUn_KN150230v1", 149710),
    new Chromosome("chrUn_KN150608v1", 149650),
    new Chromosome("chrUn_KN150046v1", 148772),
    new Chromosome("chrUn_KN149910v1", 142061),
    new Chromosome("chrUn_KN150171v1", 140649),
    new Chromosome("chrUn_KN149682v1", 137468),
    new Chromosome("chrUn_KN149962v1", 136181),
    new Chromosome("chrUn_KN149966v1", 131566),
    new Chromosome("chrUn_KN149847v1", 130903),
    new Chromosome("chrUn_KN150048v1", 128109),
    new Chromosome("chrUn_KN150435v1", 123991),
    new Chromosome("chrUn_KN150487v1", 123701),
    new Chromosome("chrUn_KN150207v1", 117821),
    new Chromosome("chrUn_KN149948v1", 117499),
    new Chromosome("chrUn_KN149790v1", 115850),
    new Chromosome("chrUn_KN149778v1", 111598),
    new Chromosome("chrUn_KN150375v1", 111208),
    new Chromosome("chrUn_KN150222v1", 110669),
    new Chromosome("chrUn_KN150425v1", 110593),
    new Chromosome("chrUn_KN150326v1", 109565),
    new Chromosome("chrUn_KN149698v1", 108577),
    new Chromosome("chrUn_KN150568v1", 108195),
    new Chromosome("chrUn_KN150129v1", 107891),
    new Chromosome("chrUn_KN149681v1", 107758),
    new Chromosome("chrUn_KN150672v1", 107610),
    new Chromosome("chrUn_KN150158v1", 106536),
    new Chromosome("chrUn_KN150021v1", 103967),
    new Chromosome("chrUn_KN150578v1", 103698),
    new Chromosome("chrUn_KN150520v1", 103159),
    new Chromosome("chrUn_KN150605v1", 102574),
    new Chromosome("chrUn_KN149797v1", 102101),
    new Chromosome("chrUn_KN149702v1", 100325),
    new Chromosome("chrUn_KN149930v1", 98773),
    new Chromosome("chrUn_KN150603v1", 98280),
    new Chromosome("chrUn_KN149748v1", 96570),
    new Chromosome("chrUn_KN149984v1", 96477),
    new Chromosome("chrUn_KN150258v1", 95885),
    new Chromosome("chrUn_KN150204v1", 95149),
    new Chromosome("chrUn_KN149895v1", 92930),
    new Chromosome("chrUn_KN150432v1", 91010),
    new Chromosome("chrUn_KN149826v1", 90482),
    new Chromosome("chrUn_KN150658v1", 90387),
    new Chromosome("chrUn_KN150617v1", 90208),
    new Chromosome("chrUn_KN150431v1", 89659),
    new Chromosome("chrUn_KN149932v1", 89521),
    new Chromosome("chrUn_KN149904v1", 89156),
    new Chromosome("chrUn_KN150196v1", 89077),
    new Chromosome("chrUn_KN150616v1", 88699),
    new Chromosome("chrUn_KN150663v1", 88608),
    new Chromosome("chrUn_KN150630v1", 86421),
    new Chromosome("chrUn_KN149963v1", 83881),
    new Chromosome("chrUn_KN150125v1", 83315),
    new Chromosome("chrUn_KN149968v1", 82990),
    new Chromosome("chrUn_KN150342v1", 82590),
    new Chromosome("chrUn_KN150133v1", 82225),
    new Chromosome("chrUn_KN150529v1", 81946),
    new Chromosome("chrUn_KN150273v1", 81940),
    new Chromosome("chrUn_KN150262v1", 81659),
    new Chromosome("chrUn_KN150649v1", 81249),
    new Chromosome("chrUn_KN150060v1", 80234),
    new Chromosome("chrUn_KN150099v1", 79937),
    new Chromosome("chrUn_KN150700v1", 79542),
    new Chromosome("chrUn_KN150712v1", 79012),
    new Chromosome("chrUn_KN150266v1", 78263),
    new Chromosome("chrUn_KN150107v1", 78223),
    new Chromosome("chrUn_KN150646v1", 78076),
    new Chromosome("chrUn_KN150670v1", 77993),
    new Chromosome("chrUn_KN149912v1", 77979),
    new Chromosome("chrUn_KN150267v1", 77778),
    new Chromosome("chrUn_KN150405v1", 76919),
    new Chromosome("chrUn_KN150471v1", 76663),
    new Chromosome("chrUn_KN149939v1", 76611),
    new Chromosome("chrUn_KN150022v1", 76538),
    new Chromosome("chrUn_KN150456v1", 76246),
    new Chromosome("chrUn_KN150339v1", 75108),
    new Chromosome("chrUn_KN149998v1", 74724),
    new Chromosome("chrUn_KN149714v1", 74622),
    new Chromosome("chrUn_KN150552v1", 74050),
    new Chromosome("chrUn_KN149784v1", 73829),
    new Chromosome("chrUn_KN150455v1", 73536),
    new Chromosome("chrUn_KN150359v1", 71383),
    new Chromosome("chrUn_KN150038v1", 71326),
    new Chromosome("chrUn_KN150131v1", 70868),
    new Chromosome("chrUn_KN150415v1", 70574),
    new Chromosome("chrUn_KN150346v1", 70538),
    new Chromosome("chrUn_KN149725v1", 69829),
    new Chromosome("chrUn_KN150000v1", 69737),
    new Chromosome("chrUn_KN150176v1", 69061),
    new Chromosome("chrUn_KN150098v1", 68279),
    new Chromosome("chrUn_KN150442v1", 67738),
    new Chromosome("chrUn_KN150122v1", 67534),
    new Chromosome("chrUn_KN150677v1", 66956),
    new Chromosome("chrUn_KN149952v1", 66365),
    new Chromosome("chrUn_KN150709v1", 65370),
    new Chromosome("chrUn_KN149718v1", 65247),
    new Chromosome("chrUn_KN149880v1", 64889),
    new Chromosome("chrUn_KN150618v1", 64127),
    new Chromosome("chrUn_KN149949v1", 64126),
    new Chromosome("chrUn_KN150666v1", 63484),
    new Chromosome("chrUn_KN150068v1", 62725),
    new Chromosome("chrUn_KN150449v1", 62607),
    new Chromosome("chrUn_KN150477v1", 61693),
    new Chromosome("chrUn_KN150031v1", 60899),
    new Chromosome("chrUn_KN150596v1", 60847),
    new Chromosome("chrUn_KN150241v1", 60821),
    new Chromosome("chrUn_KN149959v1", 59274),
    new Chromosome("chrUn_KN150476v1", 59211),
    new Chromosome("chrUn_KN149813v1", 59009),
    new Chromosome("chrUn_KN150105v1", 58062),
    new Chromosome("chrUn_KN150041v1", 58003),
    new Chromosome("chrUn_KN149992v1", 57912),
    new Chromosome("chrUn_KN149990v1", 57651),
    new Chromosome("chrUn_KN150030v1", 57074),
    new Chromosome("chrUn_KN150106v1", 56524),
    new Chromosome("chrUn_KN150033v1", 56448),
    new Chromosome("chrUn_KN150653v1", 55997),
    new Chromosome("chrUn_KN149723v1", 55784),
    new Chromosome("chrUn_KN150170v1", 55716),
    new Chromosome("chrUn_KN150642v1", 55536),
    new Chromosome("chrUn_KN150118v1", 54494),
    new Chromosome("chrUn_KN150667v1", 54201),
    new Chromosome("chrUn_KN150361v1", 53624),
    new Chromosome("chrUn_KN150232v1", 53540),
    new Chromosome("chrUn_KN149859v1", 53306),
    new Chromosome("chrUn_KN150104v1", 53188),
    new Chromosome("chrUn_KN149769v1", 53048),
    new Chromosome("chrUn_KN150123v1", 51978),
    new Chromosome("chrUn_KN149884v1", 51715),
    new Chromosome("chrUn_KN150606v1", 51696),
    new Chromosome("chrUn_KN150676v1", 51674),
    new Chromosome("chrUn_KN149739v1", 51610),
    new Chromosome("chrUn_KN150265v1", 51555),
    new Chromosome("chrUn_KN150584v1", 51535),
    new Chromosome("chrUn_KN150347v1", 51528),
    new Chromosome("chrUn_KN149812v1", 51419),
    new Chromosome("chrUn_KN150077v1", 51360),
    new Chromosome("chrUn_KN149710v1", 50974),
    new Chromosome("chrUn_KN150173v1", 50946),
    new Chromosome("chrUn_KN149868v1", 50629),
    new Chromosome("chrUn_KN149831v1", 50343),
    new Chromosome("chrUn_KN150259v1", 50098),
    new Chromosome("chrUn_KN150592v1", 50000),
    new Chromosome("chrUn_KN150351v1", 49608),
    new Chromosome("chrUn_KN150567v1", 49566),
    new Chromosome("chrUn_KN150083v1", 49514),
    new Chromosome("chrUn_KN150166v1", 49457),
    new Chromosome("chrUn_KN150136v1", 49373),
    new Chromosome("chrUn_KN150516v1", 49339),
    new Chromosome("chrUn_KN149693v1", 49295),
    new Chromosome("chrUn_KN149865v1", 49167),
    new Chromosome("chrUn_KN150336v1", 48672),
    new Chromosome("chrUn_KN150117v1", 48543),
    new Chromosome("chrUn_KN150479v1", 48186),
    new Chromosome("chrUn_KN149704v1", 48089),
    new Chromosome("chrUn_KN150269v1", 48062),
    new Chromosome("chrUn_KN150703v1", 48009),
    new Chromosome("chrUn_KN150402v1", 47971),
    new Chromosome("chrUn_KN149717v1", 47589),
    new Chromosome("chrUn_KN149719v1", 47531),
    new Chromosome("chrUn_KN150179v1", 47473),
    new Chromosome("chrUn_KN149840v1", 46864),
    new Chromosome("chrUn_KN150079v1", 46800),
    new Chromosome("chrUn_KN149760v1", 46605),
    new Chromosome("chrUn_KN149953v1", 46218),
    new Chromosome("chrUn_KN150497v1", 46188),
    new Chromosome("chrUn_KN150548v1", 46061),
    new Chromosome("chrUn_KN150459v1", 45603),
    new Chromosome("chrUn_KN150427v1", 45580),
    new Chromosome("chrUn_KN150049v1", 45008),
    new Chromosome("chrUn_KN150331v1", 44968),
    new Chromosome("chrUn_KN150243v1", 44953),
    new Chromosome("chrUn_KN149870v1", 44680),
    new Chromosome("chrUn_KN150148v1", 44589),
    new Chromosome("chrUn_KN150335v1", 44504),
    new Chromosome("chrUn_KN149858v1", 44054),
    new Chromosome("chrUn_KN150252v1", 43133),
    new Chromosome("chrUn_KN149958v1", 43073),
    new Chromosome("chrUn_KN150244v1", 42860),
    new Chromosome("chrUn_KN150348v1", 42704),
    new Chromosome("chrUn_KN150708v1", 42677),
    new Chromosome("chrUn_KN150191v1", 42303),
    new Chromosome("chrUn_KN150570v1", 42279),
    new Chromosome("chrUn_KN149716v1", 42229),
    new Chromosome("chrUn_KN149800v1", 42049),
    new Chromosome("chrUn_KN150619v1", 41925),
    new Chromosome("chrUn_KN150675v1", 41858),
    new Chromosome("chrUn_KN150557v1", 41459),
    new Chromosome("chrUn_KN150466v1", 41319),
    new Chromosome("chrUn_KN149697v1", 40969),
    new Chromosome("chrUn_KN150293v1", 40764),
    new Chromosome("chrUn_KN150172v1", 40634),
    new Chromosome("chrUn_KN150518v1", 40394),
    new Chromosome("chrUn_KN149754v1", 40214),
    new Chromosome("chrUn_KN149749v1", 40089),
    new Chromosome("chrUn_KN149909v1", 40056),
    new Chromosome("chrUn_KN149700v1", 40050),
    new Chromosome("chrUn_KN150376v1", 39971),
    new Chromosome("chrUn_KN149787v1", 39794),
    new Chromosome("chrUn_KN150638v1", 39727),
    new Chromosome("chrUn_KN150637v1", 39689),
    new Chromosome("chrUn_KN150398v1", 39557),
    new Chromosome("chrUn_KN150566v1", 39318),
    new Chromosome("chrUn_KN150303v1", 39288),
    new Chromosome("chrUn_KN150505v1", 39265),
    new Chromosome("chrUn_KN149906v1", 38987),
    new Chromosome("chrUn_KN150189v1", 38868),
    new Chromosome("chrUn_KN149680v1", 38724),
    new Chromosome("chrUn_KN149987v1", 38433),
    new Chromosome("chrUn_KN149759v1", 38290),
    new Chromosome("chrUn_KN150511v1", 38183),
    new Chromosome("chrUn_KN149929v1", 38097),
    new Chromosome("chrUn_KN150035v1", 38086),
    new Chromosome("chrUn_KN150080v1", 37662),
    new Chromosome("chrUn_KN150547v1", 37420),
    new Chromosome("chrUn_KN150609v1", 37413),
    new Chromosome("chrUn_KN150408v1", 37191),
    new Chromosome("chrUn_KN150385v1", 37055),
    new Chromosome("chrUn_KN149692v1", 36911),
    new Chromosome("chrUn_KN150137v1", 36779),
    new Chromosome("chrUn_KN149923v1", 36729),
    new Chromosome("chrUn_KN150306v1", 36728),
    new Chromosome("chrUn_KN150255v1", 36661),
    new Chromosome("chrUn_KN150091v1", 36410),
    new Chromosome("chrUn_KN150631v1", 36324),
    new Chromosome("chrUn_KN150576v1", 36129),
    new Chromosome("chrUn_KN149782v1", 36097),
    new Chromosome("chrUn_KN150386v1", 35900),
    new Chromosome("chrUn_KN150414v1", 35871),
    new Chromosome("chrUn_KN150493v1", 35575),
    new Chromosome("chrUn_KN149973v1", 35555),
    new Chromosome("chrUn_KN149679v1", 35552),
    new Chromosome("chrUn_KN149856v1", 35330),
    new Chromosome("chrUn_KN150159v1", 35229),
    new Chromosome("chrUn_KN150062v1", 35038),
    new Chromosome("chrUn_KN149836v1", 34954),
    new Chromosome("chrUn_KN150400v1", 34930),
    new Chromosome("chrUn_KN150403v1", 34697),
    new Chromosome("chrUn_KN149795v1", 34615),
    new Chromosome("chrUn_KN149989v1", 34480),
    new Chromosome("chrUn_KN150102v1", 34431),
    new Chromosome("chrUn_KN150005v1", 34409),
    new Chromosome("chrUn_KN150272v1", 34295),
    new Chromosome("chrUn_KN150498v1", 34205),
    new Chromosome("chrUn_KN150628v1", 33906),
    new Chromosome("chrUn_KN150416v1", 33835),
    new Chromosome("chrUn_KN150239v1", 33607),
    new Chromosome("chrUn_KN149996v1", 33528),
    new Chromosome("chrUn_KN150015v1", 33441),
    new Chromosome("chrUn_KN149850v1", 33401),
    new Chromosome("chrUn_KN149815v1", 33337),
    new Chromosome("chrUn_KN150127v1", 33302),
    new Chromosome("chrUn_KN149706v1", 33279),
    new Chromosome("chrUn_KN149843v1", 33258),
    new Chromosome("chrUn_KN150156v1", 33247),
    new Chromosome("chrUn_KN150208v1", 33163),
    new Chromosome("chrUn_KN149699v1", 33146),
    new Chromosome("chrUn_KN149946v1", 33071),
    new Chromosome("chrUn_KN150626v1", 32850),
    new Chromosome("chrUn_KN149830v1", 32768),
    new Chromosome("chrUn_KN150181v1", 32761),
    new Chromosome("chrUn_KN150165v1", 32739),
    new Chromosome("chrUn_KN150600v1", 32636),
    new Chromosome("chrUn_KN150055v1", 32561),
    new Chromosome("chrUn_KN150580v1", 32349),
    new Chromosome("chrUn_KN150053v1", 32328),
    new Chromosome("chrUn_KN150140v1", 32180),
    new Chromosome("chrUn_KN150043v1", 31984),
    new Chromosome("chrUn_KN150698v1", 31983),
    new Chromosome("chrUn_KN150227v1", 31979),
    new Chromosome("chrUn_KN150200v1", 31861),
    new Chromosome("chrUn_KN149982v1", 31814),
    new Chromosome("chrUn_KN150407v1", 31814),
    new Chromosome("chrUn_KN149821v1", 31785),
    new Chromosome("chrUn_KN150240v1", 31723),
    new Chromosome("chrUn_KN150492v1", 31617),
    new Chromosome("chrUn_KN150263v1", 31336),
    new Chromosome("chrUn_KN150341v1", 31147),
    new Chromosome("chrUn_KN150278v1", 30978),
    new Chromosome("chrUn_KN149767v1", 30874),
    new Chromosome("chrUn_KN150042v1", 30789),
    new Chromosome("chrUn_KN150620v1", 30729),
    new Chromosome("chrUn_KN149877v1", 30410),
    new Chromosome("chrUn_KN149753v1", 30249),
    new Chromosome("chrUn_KN149852v1", 30223),
    new Chromosome("chrUn_KN150463v1", 29963),
    new Chromosome("chrUn_KN150111v1", 29931),
    new Chromosome("chrUn_KN150379v1", 29907),
    new Chromosome("chrUn_KN149925v1", 29860),
    new Chromosome("chrUn_KN150220v1", 29625),
    new Chromosome("chrUn_KN149943v1", 29608),
    new Chromosome("chrUn_KN150696v1", 29565),
    new Chromosome("chrUn_KN150372v1", 29560),
    new Chromosome("chrUn_KN150032v1", 29546),
    new Chromosome("chrUn_KN150066v1", 29537),
    new Chromosome("chrUn_KN150056v1", 29449),
    new Chromosome("chrUn_KN150428v1", 29216),
    new Chromosome("chrUn_KN149765v1", 29197),
    new Chromosome("chrUn_KN150085v1", 29177),
    new Chromosome("chrUn_KN150349v1", 29114),
    new Chromosome("chrUn_KN150134v1", 29067),
    new Chromosome("chrUn_KN149838v1", 29025),
    new Chromosome("chrUn_KN150019v1", 28998),
    new Chromosome("chrUn_KN150572v1", 28871),
    new Chromosome("chrUn_KN150001v1", 28767),
    new Chromosome("chrUn_KN150340v1", 28741),
    new Chromosome("chrUn_KN149846v1", 28664),
    new Chromosome("chrUn_KN150074v1", 28653),
    new Chromosome("chrUn_KN150330v1", 28440),
    new Chromosome("chrUn_KN150168v1", 28382),
    new Chromosome("chrUn_KN149921v1", 28254),
    new Chromosome("chrUn_KN150495v1", 28160),
    new Chromosome("chrUn_KN150221v1", 28122),
    new Chromosome("chrUn_KN150643v1", 28088),
    new Chromosome("chrUn_KN150178v1", 28040),
    new Chromosome("chrUn_KN150651v1", 28018),
    new Chromosome("chrUn_KN150656v1", 28006),
    new Chromosome("chrUn_KN149893v1", 27995),
    new Chromosome("chrUn_KN150635v1", 27947),
    new Chromosome("chrUn_KN149705v1", 27926),
    new Chromosome("chrUn_KN149709v1", 27814),
    new Chromosome("chrUn_KN149737v1", 27700),
    new Chromosome("chrUn_KN150639v1", 27620),
    new Chromosome("chrUn_KN150537v1", 27568),
    new Chromosome("chrUn_KN150120v1", 27511),
    new Chromosome("chrUn_KN150357v1", 27326),
    new Chromosome("chrUn_KN150067v1", 27325),
    new Chromosome("chrUn_KN149829v1", 27323),
    new Chromosome("chrUn_KN150151v1", 27317),
    new Chromosome("chrUn_KN150124v1", 27208),
    new Chromosome("chrUn_KN149799v1", 27060),
    new Chromosome("chrUn_KN150251v1", 26988),
    new Chromosome("chrUn_KN150343v1", 26928),
    new Chromosome("chrUn_KN150508v1", 26814),
    new Chromosome("chrUn_KN150489v1", 26739),
    new Chromosome("chrUn_KN150573v1", 26604),
    new Chromosome("chrUn_KN150559v1", 26580),
    new Chromosome("chrUn_KN150391v1", 26543),
    new Chromosome("chrUn_KN150025v1", 26343),
    new Chromosome("chrUn_KN150661v1", 26250),
    new Chromosome("chrUn_KN150690v1", 26145),
    new Chromosome("chrUn_KN150699v1", 26100),
    new Chromosome("chrUn_KN150627v1", 26060),
    new Chromosome("chrUn_KN149818v1", 25942),
    new Chromosome("chrUn_KN149814v1", 25878),
    new Chromosome("chrUn_KN149835v1", 25861),
    new Chromosome("chrUn_KN150478v1", 25813),
    new Chromosome("chrUn_KN150291v1", 25796),
    new Chromosome("chrUn_KN150017v1", 25636),
    new Chromosome("chrUn_KN149796v1", 25635),
    new Chromosome("chrUn_KN149721v1", 25462),
    new Chromosome("chrUn_KN149794v1", 25440),
    new Chromosome("chrUn_KN150468v1", 25381),
    new Chromosome("chrUn_KN150450v1", 25362),
    new Chromosome("chrUn_KN150285v1", 25361),
    new Chromosome("chrUn_KN150226v1", 25293),
    new Chromosome("chrUn_KN150604v1", 25236),
    new Chromosome("chrUn_KN150101v1", 25174),
    new Chromosome("chrUn_KN149944v1", 24909),
    new Chromosome("chrUn_KN149727v1", 24871),
    new Chromosome("chrUn_KN150464v1", 24865),
    new Chromosome("chrUn_KN150126v1", 24847),
    new Chromosome("chrUn_KN149892v1", 24638),
    new Chromosome("chrUn_KN150462v1", 24623),
    new Chromosome("chrUn_KN150175v1", 24612),
    new Chromosome("chrUn_KN150569v1", 24359),
    new Chromosome("chrUn_KN150088v1", 24203),
    new Chromosome("chrUn_KN150084v1", 24192),
    new Chromosome("chrUn_KN150114v1", 24178),
    new Chromosome("chrUn_KN150224v1", 24154),
    new Chromosome("chrUn_KN150684v1", 24053),
    new Chromosome("chrUn_KN150061v1", 24048),
    new Chromosome("chrUn_KN150324v1", 24032),
    new Chromosome("chrUn_KN150203v1", 24004),
    new Chromosome("chrUn_KN150186v1", 23923),
    new Chromosome("chrUn_KN150282v1", 23758),
    new Chromosome("chrUn_KN150579v1", 23586),
    new Chromosome("chrUn_KN150299v1", 23511),
    new Chromosome("chrUn_KN150297v1", 23472),
    new Chromosome("chrUn_KN149924v1", 23395),
    new Chromosome("chrUn_KN149947v1", 23293),
    new Chromosome("chrUn_KN150305v1", 23261),
    new Chromosome("chrUn_KN150539v1", 23246),
    new Chromosome("chrUn_KN150045v1", 23207),
    new Chromosome("chrUn_KN149855v1", 23165),
    new Chromosome("chrUn_KN150490v1", 23057),
    new Chromosome("chrUn_KN150384v1", 22969),
    new Chromosome("chrUn_KN150562v1", 22875),
    new Chromosome("chrUn_KN150332v1", 22862),
    new Chromosome("chrUn_KN150645v1", 22839),
    new Chromosome("chrUn_KN149979v1", 22834),
    new Chromosome("chrUn_KN150363v1", 22766),
    new Chromosome("chrUn_KN150602v1", 22730),
    new Chromosome("chrUn_KN149871v1", 22553),
    new Chromosome("chrUn_KN150334v1", 22542),
    new Chromosome("chrUn_KN150625v1", 22486),
    new Chromosome("chrUn_KN150501v1", 22392),
    new Chromosome("chrUn_KN150270v1", 22285),
    new Chromosome("chrUn_KN150388v1", 22284),
    new Chromosome("chrUn_KN150183v1", 22266),
    new Chromosome("chrUn_KN150561v1", 22238),
    new Chromosome("chrUn_KN150289v1", 22206),
    new Chromosome("chrUn_KN150023v1", 22153),
    new Chromosome("chrUn_KN149825v1", 22128),
    new Chromosome("chrUn_KN149741v1", 21941),
    new Chromosome("chrUn_KN150668v1", 21856),
    new Chromosome("chrUn_KN150154v1", 21695),
    new Chromosome("chrUn_KN150177v1", 21670),
    new Chromosome("chrUn_KN149779v1", 21664),
    new Chromosome("chrUn_KN149733v1", 21637),
    new Chromosome("chrUn_KN150532v1", 21602),
    new Chromosome("chrUn_KN150016v1", 21592),
    new Chromosome("chrUn_KN150426v1", 21499),
    new Chromosome("chrUn_KN149869v1", 21474),
    new Chromosome("chrUn_KN150058v1", 21348),
    new Chromosome("chrUn_KN149919v1", 21073),
    new Chromosome("chrUn_KN150496v1", 21062),
    new Chromosome("chrUn_KN149743v1", 21023),
    new Chromosome("chrUn_KN150309v1", 20999),
    new Chromosome("chrUn_KN150521v1", 20896),
    new Chromosome("chrUn_KN150640v1", 20890),
    new Chromosome("chrUn_KN150411v1", 20886),
    new Chromosome("chrUn_KN150527v1", 20880),
    new Chromosome("chrUn_KN150063v1", 20846),
    new Chromosome("chrUn_KN150047v1", 20749),
    new Chromosome("chrUn_KN150313v1", 20655),
    new Chromosome("chrUn_KN149961v1", 20600),
    new Chromosome("chrUn_KN149708v1", 20567),
    new Chromosome("chrUn_KN150644v1", 20534),
    new Chromosome("chrUn_KN150636v1", 20513),
    new Chromosome("chrUn_KN150310v1", 20509),
    new Chromosome("chrUn_KN150565v1", 20464),
    new Chromosome("chrUn_KN150225v1", 20429),
    new Chromosome("chrUn_KN150315v1", 20424),
    new Chromosome("chrUn_KN149849v1", 20421),
    new Chromosome("chrUn_KN150337v1", 20260),
    new Chromosome("chrUn_KN149977v1", 20138),
    new Chromosome("chrUn_KN150242v1", 20063),
    new Chromosome("chrUn_KN150327v1", 19949),
    new Chromosome("chrUn_KN150040v1", 19896),
    new Chromosome("chrUn_KN150500v1", 19866),
    new Chromosome("chrUn_KN149764v1", 19831),
    new Chromosome("chrUn_KN149955v1", 19758),
    new Chromosome("chrUn_KN149780v1", 19718),
    new Chromosome("chrUn_KN150344v1", 19681),
    new Chromosome("chrUn_KN149763v1", 19644),
    new Chromosome("chrUn_KN150322v1", 19644),
    new Chromosome("chrUn_KN150353v1", 19631),
    new Chromosome("chrUn_KN150710v1", 19629),
    new Chromosome("chrUn_KN150629v1", 19604),
    new Chromosome("chrUn_KN149974v1", 19596),
    new Chromosome("chrUn_KN150003v1", 19572),
    new Chromosome("chrUn_KN150633v1", 19558),
    new Chromosome("chrUn_KN150689v1", 19550),
    new Chromosome("chrUn_KN150325v1", 19525),
    new Chromosome("chrUn_KN150028v1", 19517),
    new Chromosome("chrUn_KN150108v1", 19459),
    new Chromosome("chrUn_KN149731v1", 19431),
    new Chromosome("chrUn_KN150514v1", 19391),
    new Chromosome("chrUn_KN150594v1", 19382),
    new Chromosome("chrUn_KN150399v1", 19362),
    new Chromosome("chrUn_KN150236v1", 19315),
    new Chromosome("chrUn_KN150113v1", 19310),
    new Chromosome("chrUn_KN150187v1", 19179),
    new Chromosome("chrUn_KN149744v1", 19164),
    new Chromosome("chrUn_KN150390v1", 19066),
    new Chromosome("chrUn_KN149715v1", 19020),
    new Chromosome("chrUn_KN150599v1", 19019),
    new Chromosome("chrUn_KN150523v1", 19004),
    new Chromosome("chrUn_KN150589v1", 18957),
    new Chromosome("chrUn_KN150212v1", 18932),
    new Chromosome("chrUn_KN150195v1", 18921),
    new Chromosome("chrUn_KN150308v1", 18907),
    new Chromosome("chrUn_KN149775v1", 18776),
    new Chromosome("chrUn_KN150157v1", 18756),
    new Chromosome("chrUn_KN150624v1", 18713),
    new Chromosome("chrUn_KN150115v1", 18676),
    new Chromosome("chrUn_KN150301v1", 18664),
    new Chromosome("chrUn_KN150234v1", 18511),
    new Chromosome("chrUn_KN150574v1", 18499),
    new Chromosome("chrUn_KN150368v1", 18491),
    new Chromosome("chrUn_KN150454v1", 18479),
    new Chromosome("chrUn_KN150654v1", 18414),
    new Chromosome("chrUn_KN150248v1", 18273),
    new Chromosome("chrUn_KN150290v1", 18248),
    new Chromosome("chrUn_KN149914v1", 18241),
    new Chromosome("chrUn_KN150198v1", 18196),
    new Chromosome("chrUn_KN149920v1", 18168),
    new Chromosome("chrUn_KN150404v1", 18160),
    new Chromosome("chrUn_KN150323v1", 18137),
    new Chromosome("chrUn_KN150284v1", 18131),
    new Chromosome("chrUn_KN150652v1", 18075),
    new Chromosome("chrUn_KN149762v1", 17936),
    new Chromosome("chrUn_KN150536v1", 17908),
    new Chromosome("chrUn_KN149983v1", 17884),
    new Chromosome("chrUn_KN150160v1", 17824),
    new Chromosome("chrUn_KN150662v1", 17820),
    new Chromosome("chrUn_KN150436v1", 17739),
    new Chromosome("chrUn_KN150009v1", 17727),
    new Chromosome("chrUn_KN150564v1", 17709),
    new Chromosome("chrUn_KN150429v1", 17683),
    new Chromosome("chrUn_KN149768v1", 17671),
    new Chromosome("chrUn_KN150534v1", 17661),
    new Chromosome("chrUn_KN149842v1", 17614),
    new Chromosome("chrUn_KN150549v1", 17599),
    new Chromosome("chrUn_KN150488v1", 17582),
    new Chromosome("chrUn_KN150545v1", 17546),
    new Chromosome("chrUn_KN150475v1", 17517),
    new Chromosome("chrUn_KN149970v1", 17511),
    new Chromosome("chrUn_KN150458v1", 17481),
    new Chromosome("chrUn_KN150002v1", 17430),
    new Chromosome("chrUn_KN150328v1", 17410),
    new Chromosome("chrUn_KN149860v1", 17408),
    new Chromosome("chrUn_KN150256v1", 17390),
    new Chromosome("chrUn_KN150586v1", 17388),
    new Chromosome("chrUn_KN149834v1", 17343),
    new Chromosome("chrUn_KN150483v1", 17332),
    new Chromosome("chrUn_KN150397v1", 17295),
    new Chromosome("chrUn_KN150312v1", 17282),
    new Chromosome("chrUn_KN149791v1", 17273),
    new Chromosome("chrUn_KN150406v1", 17215),
    new Chromosome("chrUn_KN150362v1", 17145),
    new Chromosome("chrUn_KN150394v1", 17139),
    new Chromosome("chrUn_KN149888v1", 17117),
    new Chromosome("chrUn_KN150141v1", 17117),
    new Chromosome("chrUn_KN150228v1", 17061),
    new Chromosome("chrUn_KN150345v1", 17012),
    new Chromosome("chrUn_KN150264v1", 16955),
    new Chromosome("chrUn_KN150707v1", 16938),
    new Chromosome("chrUn_KN149993v1", 16921),
    new Chromosome("chrUn_KN150683v1", 16822),
    new Chromosome("chrUn_KN149978v1", 16801),
    new Chromosome("chrUn_KN150219v1", 16672),
    new Chromosome("chrUn_KN150139v1", 16647),
    new Chromosome("chrUn_KN149752v1", 16628),
    new Chromosome("chrUn_KN150059v1", 16588),
    new Chromosome("chrUn_KN150199v1", 16564),
    new Chromosome("chrUn_KN150571v1", 16505),
    new Chromosome("chrUn_KN149913v1", 16487),
    new Chromosome("chrUn_KN150430v1", 16452),
    new Chromosome("chrUn_KN150211v1", 16386),
    new Chromosome("chrUn_KN150705v1", 16373),
    new Chromosome("chrUn_KN150184v1", 16312),
    new Chromosome("chrUn_KN149747v1", 16275),
    new Chromosome("chrUn_KN150517v1", 16171),
    new Chromosome("chrUn_KN149757v1", 16145),
    new Chromosome("chrUn_KN150054v1", 16143),
    new Chromosome("chrUn_KN150213v1", 16101),
    new Chromosome("chrUn_KN149936v1", 16058),
    new Chromosome("chrUn_KN150142v1", 16050),
    new Chromosome("chrUn_KN149902v1", 16044),
    new Chromosome("chrUn_KN149732v1", 16041),
    new Chromosome("chrUn_KN150634v1", 16020),
    new Chromosome("chrUn_KN149803v1", 16018),
    new Chromosome("chrUn_KN150052v1", 15943),
    new Chromosome("chrUn_KN150352v1", 15907),
    new Chromosome("chrUn_KN149751v1", 15848),
    new Chromosome("chrUn_KN150622v1", 15811),
    new Chromosome("chrUn_KN150319v1", 15807),
    new Chromosome("chrUn_KN150311v1", 15747),
    new Chromosome("chrUn_KN150613v1", 15739),
    new Chromosome("chrUn_KN150360v1", 15639),
    new Chromosome("chrUn_KN150008v1", 15572),
    new Chromosome("chrUn_KN150526v1", 15513),
    new Chromosome("chrUn_KN150116v1", 15497),
    new Chromosome("chrUn_KN149808v1", 15454),
    new Chromosome("chrUn_KN150202v1", 15451),
    new Chromosome("chrUn_KN150246v1", 15365),
    new Chromosome("chrUn_KN150218v1", 15354),
    new Chromosome("chrUn_KN150669v1", 15325),
    new Chromosome("chrUn_KN150540v1", 15288),
    new Chromosome("chrUn_KN150268v1", 15280),
    new Chromosome("chrUn_KN150423v1", 15221),
    new Chromosome("chrUn_KN150387v1", 15215),
    new Chromosome("chrUn_KN150682v1", 15190),
    new Chromosome("chrUn_KN149806v1", 15157),
    new Chromosome("chrUn_KN150531v1", 15090),
    new Chromosome("chrUn_KN150364v1", 15084),
    new Chromosome("chrUn_KN150413v1", 15078),
    new Chromosome("chrUn_KN149894v1", 15058),
    new Chromosome("chrUn_KN150422v1", 15053),
    new Chromosome("chrUn_KN149810v1", 15043),
    new Chromosome("chrUn_KN150144v1", 14974),
    new Chromosome("chrUn_KN150484v1", 14965),
    new Chromosome("chrUn_KN150071v1", 14960),
    new Chromosome("chrUn_KN150421v1", 14951),
    new Chromosome("chrUn_KN150647v1", 14938),
    new Chromosome("chrUn_KN150418v1", 14930),
    new Chromosome("chrUn_KN150451v1", 14920),
    new Chromosome("chrUn_KN150550v1", 14915),
    new Chromosome("chrUn_KN150482v1", 14895),
    new Chromosome("chrUn_KN150317v1", 14866),
    new Chromosome("chrUn_KN150410v1", 14841),
    new Chromosome("chrUn_KN150695v1", 14840),
    new Chromosome("chrUn_KN149730v1", 14804),
    new Chromosome("chrUn_KN149761v1", 14795),
    new Chromosome("chrUn_KN149965v1", 14790),
    new Chromosome("chrUn_KN150641v1", 14778),
    new Chromosome("chrUn_KN149866v1", 14752),
    new Chromosome("chrUn_KN150093v1", 14738),
    new Chromosome("chrUn_KN150010v1", 14703),
    new Chromosome("chrUn_KN149766v1", 14664),
    new Chromosome("chrUn_KN150469v1", 14614),
    new Chromosome("chrUn_KN150064v1", 14598),
    new Chromosome("chrUn_KN150472v1", 14586),
    new Chromosome("chrUn_KN150713v1", 14579),
    new Chromosome("chrUn_KN150092v1", 14544),
    new Chromosome("chrUn_KN150197v1", 14532),
    new Chromosome("chrUn_KN150076v1", 14425),
    new Chromosome("chrUn_KN150138v1", 14383),
    new Chromosome("chrUn_KN150593v1", 14353),
    new Chromosome("chrUn_KN149861v1", 14336),
    new Chromosome("chrUn_KN150506v1", 14319),
    new Chromosome("chrUn_KN149928v1", 14297),
    new Chromosome("chrUn_KN150420v1", 14290),
    new Chromosome("chrUn_KN149771v1", 14151),
    new Chromosome("chrUn_KN150419v1", 14114),
    new Chromosome("chrUn_KN149937v1", 14110),
    new Chromosome("chrUn_KN150588v1", 14103),
    new Chromosome("chrUn_KN150382v1", 14074),
    new Chromosome("chrUn_KN149999v1", 14071),
    new Chromosome("chrUn_KN150070v1", 14070),
    new Chromosome("chrUn_KN150679v1", 14065),
    new Chromosome("chrUn_KN149905v1", 14056),
    new Chromosome("chrUn_KN150073v1", 14052),
    new Chromosome("chrUn_KN149897v1", 14044),
    new Chromosome("chrUn_KN149823v1", 14034),
    new Chromosome("chrUn_KN150553v1", 14032),
    new Chromosome("chrUn_KN150512v1", 14003),
    new Chromosome("chrUn_KN150132v1", 13999),
    new Chromosome("chrUn_KN150674v1", 13959),
    new Chromosome("chrUn_KN150283v1", 13933),
    new Chromosome("chrUn_KN149750v1", 13928),
    new Chromosome("chrUn_KN149703v1", 13902),
    new Chromosome("chrUn_KN150075v1", 13883),
    new Chromosome("chrUn_KN150217v1", 13840),
    new Chromosome("chrUn_KN150371v1", 13836),
    new Chromosome("chrUn_KN150275v1", 13800),
    new Chromosome("chrUn_KN150577v1", 13719),
    new Chromosome("chrUn_KN149969v1", 13714),
    new Chromosome("chrUn_KN150235v1", 13664),
    new Chromosome("chrUn_KN149899v1", 13632),
    new Chromosome("chrUn_KN150194v1", 13629),
    new Chromosome("chrUn_KN149941v1", 13607),
    new Chromosome("chrUn_KN150453v1", 13591),
    new Chromosome("chrUn_KN150014v1", 13588),
    new Chromosome("chrUn_KN150250v1", 13560),
    new Chromosome("chrUn_KN149827v1", 13555),
    new Chromosome("chrUn_KN150302v1", 13538),
    new Chromosome("chrUn_KN150671v1", 13526),
    new Chromosome("chrUn_KN150694v1", 13510),
    new Chromosome("chrUn_KN150660v1", 13470),
    new Chromosome("chrUn_KN150167v1", 13466),
    new Chromosome("chrUn_KN150174v1", 13450),
    new Chromosome("chrUn_KN149933v1", 13433),
    new Chromosome("chrUn_KN149722v1", 13397),
    new Chromosome("chrUn_KN150680v1", 13379),
    new Chromosome("chrUn_KN149875v1", 13354),
    new Chromosome("chrUn_KN150072v1", 13309),
    new Chromosome("chrUn_KN150685v1", 13309),
    new Chromosome("chrUn_KN149793v1", 13298),
    new Chromosome("chrUn_KN150329v1", 13297),
    new Chromosome("chrUn_KN150687v1", 13294),
    new Chromosome("chrUn_KN149772v1", 13273),
    new Chromosome("chrUn_KN150510v1", 13237),
    new Chromosome("chrUn_KN150528v1", 13138),
    new Chromosome("chrUn_KN150373v1", 13130),
    new Chromosome("chrUn_KN150089v1", 13104),
    new Chromosome("chrUn_KN149896v1", 13102),
    new Chromosome("chrUn_KN150007v1", 13072),
    new Chromosome("chrUn_KN150502v1", 13027),
    new Chromosome("chrUn_KN150491v1", 13001),
    new Chromosome("chrUn_KN149839v1", 12998),
    new Chromosome("chrUn_KN150011v1", 12995),
    new Chromosome("chrUn_KN149789v1", 12990),
    new Chromosome("chrUn_KN150276v1", 12942),
    new Chromosome("chrUn_KN149864v1", 12929),
    new Chromosome("chrUn_KN150081v1", 12836),
    new Chromosome("chrUn_KN149853v1", 12817),
    new Chromosome("chrUn_KN149981v1", 12811),
    new Chromosome("chrUn_KN149908v1", 12800),
    new Chromosome("chrUn_KN150069v1", 12799),
    new Chromosome("chrUn_KN150257v1", 12735),
    new Chromosome("chrUn_KN150697v1", 12709),
    new Chromosome("chrUn_KN150161v1", 12647),
    new Chromosome("chrUn_KN150271v1", 12637),
    new Chromosome("chrUn_KN150507v1", 12629),
    new Chromosome("chrUn_KN150692v1", 12590),
    new Chromosome("chrUn_KN150193v1", 12580),
    new Chromosome("chrUn_KN150210v1", 12550),
    new Chromosome("chrUn_KN149922v1", 12529),
    new Chromosome("chrUn_KN149807v1", 12512),
    new Chromosome("chrUn_KN150595v1", 12507),
    new Chromosome("chrUn_KN150598v1", 12499),
    new Chromosome("chrUn_KN150288v1", 12496),
    new Chromosome("chrUn_KN149832v1", 12483),
    new Chromosome("chrUn_KN149938v1", 12455),
    new Chromosome("chrUn_KN150314v1", 12455),
    new Chromosome("chrUn_KN149934v1", 12451),
    new Chromosome("chrUn_KN150446v1", 12446),
    new Chromosome("chrUn_KN150441v1", 12439),
    new Chromosome("chrUn_KN149883v1", 12434),
    new Chromosome("chrUn_KN149805v1", 12432),
    new Chromosome("chrUn_KN150585v1", 12430),
    new Chromosome("chrUn_KN150029v1", 12415),
    new Chromosome("chrUn_KN150582v1", 12396),
    new Chromosome("chrUn_KN150581v1", 12355),
    new Chromosome("chrUn_KN149774v1", 12337),
    new Chromosome("chrUn_KN150541v1", 12323),
    new Chromosome("chrUn_KN150260v1", 12318),
    new Chromosome("chrUn_KN150333v1", 12275),
    new Chromosome("chrUn_KN150128v1", 12262),
    new Chromosome("chrUn_KN150249v1", 12261),
    new Chromosome("chrUn_KN150274v1", 12247),
    new Chromosome("chrUn_KN149872v1", 12222),
    new Chromosome("chrUn_KN150542v1", 12167),
    new Chromosome("chrUn_KN150254v1", 12144),
    new Chromosome("chrUn_KN150380v1", 12144),
    new Chromosome("chrUn_KN150538v1", 12119),
    new Chromosome("chrUn_KN150558v1", 12115),
    new Chromosome("chrUn_KN150078v1", 12098),
    new Chromosome("chrUn_KN149851v1", 12094),
    new Chromosome("chrUn_KN150504v1", 12094),
    new Chromosome("chrUn_KN150393v1", 12073),
    new Chromosome("chrUn_KN150445v1", 12072),
    new Chromosome("chrUn_KN150392v1", 12069),
    new Chromosome("chrUn_KN150434v1", 12053),
    new Chromosome("chrUn_KN149770v1", 12046),
    new Chromosome("chrUn_KN150522v1", 12046),
    new Chromosome("chrUn_KN149890v1", 12029),
    new Chromosome("chrUn_KN150090v1", 12028),
    new Chromosome("chrUn_KN149995v1", 12015),
    new Chromosome("chrUn_KN150012v1", 11998),
    new Chromosome("chrUn_KN149862v1", 11987),
    new Chromosome("chrUn_KN150519v1", 11974),
    new Chromosome("chrUn_KN149887v1", 11971),
    new Chromosome("chrUn_KN149863v1", 11955),
    new Chromosome("chrUn_KN149927v1", 11950),
    new Chromosome("chrUn_KN150686v1", 11947),
    new Chromosome("chrUn_KN150665v1", 11944),
    new Chromosome("chrUn_KN149755v1", 11941),
    new Chromosome("chrUn_KN150711v1", 11940),
    new Chromosome("chrUn_KN150424v1", 11928),
    new Chromosome("chrUn_KN150020v1", 11925),
    new Chromosome("chrUn_KN149879v1", 11893),
    new Chromosome("chrUn_KN149783v1", 11892),
    new Chromosome("chrUn_KN149940v1", 11887),
    new Chromosome("chrUn_KN149976v1", 11858),
    new Chromosome("chrUn_KN150287v1", 11856),
    new Chromosome("chrUn_KN149724v1", 11849),
    new Chromosome("chrUn_KN150509v1", 11846),
    new Chromosome("chrUn_KN150499v1", 11840),
    new Chromosome("chrUn_KN150443v1", 11834),
    new Chromosome("chrUn_KN150444v1", 11830),
    new Chromosome("chrUn_KN150659v1", 11827),
    new Chromosome("chrUn_KN149756v1", 11785),
    new Chromosome("chrUn_KN150182v1", 11735),
    new Chromosome("chrUn_KN150097v1", 11690),
    new Chromosome("chrUn_KN150632v1", 11627),
    new Chromosome("chrUn_KN149964v1", 11592),
    new Chromosome("chrUn_KN150096v1", 11550),
    new Chromosome("chrUn_KN150563v1", 11540),
    new Chromosome("chrUn_KN150316v1", 11489),
    new Chromosome("chrUn_KN149711v1", 11473),
    new Chromosome("chrUn_KN150369v1", 11460),
    new Chromosome("chrUn_KN150004v1", 11444),
    new Chromosome("chrUn_KN149828v1", 11414),
    new Chromosome("chrUn_KN150279v1", 11402),
    new Chromosome("chrUn_KN150190v1", 11399),
    new Chromosome("chrUn_KN149903v1", 11318),
    new Chromosome("chrUn_KN150164v1", 11300),
    new Chromosome("chrUn_KN149876v1", 11298),
    new Chromosome("chrUn_KN149971v1", 11275),
    new Chromosome("chrUn_KN149792v1", 11232),
    new Chromosome("chrUn_KN150467v1", 11202),
    new Chromosome("chrUn_KN150601v1", 11167),
    new Chromosome("chrUn_KN149911v1", 11128),
    new Chromosome("chrUn_KN149817v1", 11116),
    new Chromosome("chrUn_KN150575v1", 11084),
    new Chromosome("chrUn_KN150087v1", 11020),
    new Chromosome("chrUn_KN149900v1", 11016),
    new Chromosome("chrUn_KN150162v1", 10930),
    new Chromosome("chrUn_KN149746v1", 10900),
    new Chromosome("chrUn_KN150546v1", 10851),
    new Chromosome("chrUn_KN150365v1", 10769),
    new Chromosome("chrUn_KN149891v1", 10762),
    new Chromosome("chrUn_KN149881v1", 10736),
    new Chromosome("chrUn_KN150057v1", 10736),
    new Chromosome("chrUn_KN149738v1", 10603),
    new Chromosome("chrUn_KN150610v1", 10565),
    new Chromosome("chrUn_KN150006v1", 10518),
    new Chromosome("chrUn_KN149901v1", 10512),
    new Chromosome("chrUn_KN150280v1", 10487),
    new Chromosome("chrUn_KN149915v1", 10395),
    new Chromosome("chrUn_KN150439v1", 10343),
    new Chromosome("chrUn_KN149848v1", 10341),
    new Chromosome("chrUn_KN150389v1", 10334),
    new Chromosome("chrUn_KN150155v1", 10282),
    new Chromosome("chrUn_KN150296v1", 10238),
    new Chromosome("chrUn_KN150513v1", 10220),
    new Chromosome("chrUn_KN149720v1", 10211),
    new Chromosome("chrUn_KN149819v1", 10210),
    new Chromosome("chrUn_KN149844v1", 10201),
    new Chromosome("chrUn_KN149889v1", 10166),
    new Chromosome("chrUn_KN149804v1", 10148),
    new Chromosome("chrUn_KN149857v1", 10132),
    new Chromosome("chrUn_KN149816v1", 10128),
    new Chromosome("chrUn_KN150494v1", 10108),
    new Chromosome("chrUn_KN149713v1", 10094),
    new Chromosome("chrUn_KN149841v1", 10085),
    new Chromosome("chrUn_KN150401v1", 10081),
    new Chromosome("chrUn_KN150366v1", 10057),
    new Chromosome("chrUn_KN150304v1", 10004),
    new Chromosome("chrUn_KN149945v1", 9994),
    new Chromosome("chrUn_KN150292v1", 9984),
    new Chromosome("chrUn_KN150145v1", 9970),
    new Chromosome("chrUn_KN149781v1", 9962),
    new Chromosome("chrUn_KN150358v1", 9951),
    new Chromosome("chrUn_KN150524v1", 9948),
    new Chromosome("chrUn_KN149988v1", 9944),
    new Chromosome("chrUn_KN150555v1", 9941),
    new Chromosome("chrUn_KN150130v1", 9925),
    new Chromosome("chrUn_KN150615v1", 9878),
    new Chromosome("chrUn_KN149991v1", 9871),
    new Chromosome("chrUn_KN149907v1", 9870),
    new Chromosome("chrUn_KN150065v1", 9859),
    new Chromosome("chrUn_KN150188v1", 9856),
    new Chromosome("chrUn_KN150110v1", 9804),
    new Chromosome("chrUn_KN150395v1", 9792),
    new Chromosome("chrUn_KN150150v1", 9780),
    new Chromosome("chrUn_KN150374v1", 9775),
    new Chromosome("chrUn_KN150146v1", 9714),
    new Chromosome("chrUn_KN150412v1", 9605),
    new Chromosome("chrUn_KN150664v1", 9590),
    new Chromosome("chrUn_KN150607v1", 9531),
    new Chromosome("chrUn_KN149942v1", 9522),
    new Chromosome("chrUn_KN149758v1", 9515),
    new Chromosome("chrUn_KN150300v1", 9489),
    new Chromosome("chrUn_KN150201v1", 9480),
    new Chromosome("chrUn_KN150238v1", 9450),
    new Chromosome("chrUn_KN149728v1", 9442),
    new Chromosome("chrUn_KN150551v1", 9435),
    new Chromosome("chrUn_KN150152v1", 9348),
    new Chromosome("chrUn_KN150556v1", 9286),
    new Chromosome("chrUn_KN150554v1", 9251),
    new Chromosome("chrUn_KN150350v1", 9245),
    new Chromosome("chrUn_KN150100v1", 9237),
    new Chromosome("chrUn_KN149960v1", 9235),
    new Chromosome("chrUn_KN149935v1", 9230),
    new Chromosome("chrUn_KN150095v1", 9204),
    new Chromosome("chrUn_KN150307v1", 9167),
    new Chromosome("chrUn_KN150044v1", 9097),
    new Chromosome("chrUn_KN150286v1", 9068),
    new Chromosome("chrUn_KN150614v1", 9019),
    new Chromosome("chrUn_KN150591v1", 8817),
    new Chromosome("chrUn_KN150245v1", 8814),
    new Chromosome("chrUn_KN149986v1", 8801),
    new Chromosome("chrUn_KN149788v1", 8794),
    new Chromosome("chrUn_KN150082v1", 8788),
    new Chromosome("chrUn_KN149811v1", 8720),
    new Chromosome("chrUn_KN150185v1", 8651),
    new Chromosome("chrUn_KN149967v1", 8612),
    new Chromosome("chrUn_KN150381v1", 8595),
    new Chromosome("chrUn_KN150486v1", 8572),
    new Chromosome("chrUn_KN150013v1", 8488),
    new Chromosome("chrUn_KN150587v1", 8461),
    new Chromosome("chrUn_KN150121v1", 8447),
    new Chromosome("chrUn_KN150452v1", 8345),
    new Chromosome("chrUn_KN150433v1", 8322),
    new Chromosome("chrUn_KN150706v1", 8278),
    new Chromosome("chrUn_KN150050v1", 8203),
    new Chromosome("chrUn_KN150396v1", 8176),
    new Chromosome("chrUn_KN149745v1", 8150),
    new Chromosome("chrUn_KN150655v1", 8089),
    new Chromosome("chrUn_KN149837v1", 8007),
    new Chromosome("chrUn_KN149980v1", 7980),
    new Chromosome("chrUn_KN150147v1", 7977),
    new Chromosome("chrUn_KN150094v1", 7824),
    new Chromosome("chrUn_KN150383v1", 7777),
    new Chromosome("chrUn_KN149882v1", 7649),
    new Chromosome("chrUn_KN150438v1", 7619),
    new Chromosome("chrUn_KN150678v1", 7552),
    new Chromosome("chrUn_KN149878v1", 7547),
    new Chromosome("chrUn_KN150485v1", 7348),
    new Chromosome("chrUn_KN150530v1", 7299),
    new Chromosome("chrUn_KN150169v1", 7260),
    new Chromosome("chrUn_KN150135v1", 6944),
    new Chromosome("chrUn_KN150447v1", 6779),
    new Chromosome("chrUn_KN150355v1", 6731),
    new Chromosome("chrUn_KN149931v1", 6703),
    new Chromosome("chrUn_KN149854v1", 6367),
    new Chromosome("chrUn_KN149997v1", 6296),
    new Chromosome("chrUn_KN149734v1", 6288),
    new Chromosome("chrUn_KN149918v1", 6170),
    new Chromosome("chrUn_KN149707v1", 6001),
    new Chromosome("chrUn_KN149950v1", 5952),
    new Chromosome("chrUn_KN150590v1", 5798),
    new Chromosome("chrUn_KN149735v1", 5747),
    new Chromosome("chrUn_KN150377v1", 5727),
    new Chromosome("chrUn_KN149729v1", 5608),
    new Chromosome("chrUn_KN150261v1", 5601),
    new Chromosome("chrUn_KN150109v1", 5564),
    new Chromosome("chrUn_KN150295v1", 5486),
    new Chromosome("chrUn_KN149874v1", 5295),
    new Chromosome("chrUn_KN149951v1", 5000),
    new Chromosome("chrUn_KN150143v1", 4977),
    new Chromosome("chrUn_KN149898v1", 4537),
    new Chromosome("chrUn_KN149801v1", 4454),
    new Chromosome("chrUn_KN150036v1", 4412),
    new Chromosome("chrUn_KN150209v1", 4398),
    new Chromosome("chrUn_KN149916v1", 4293),
    new Chromosome("chrUn_KN150378v1", 4206),
    new Chromosome("chrUn_KN150103v1", 4090),
    new Chromosome("chrUn_KN149917v1", 3831),
    new Chromosome("chrUn_KN149802v1", 3818),
    new Chromosome("chrUn_KN150149v1", 3784),
    new Chromosome("chrUn_KN150281v1", 3763),
    new Chromosome("chrUn_KN149701v1", 3760),
    new Chromosome("chrUn_KN150448v1", 3709),
    new Chromosome("chrUn_KN149926v1", 3688),
    new Chromosome("chrUn_KN150039v1", 3463),
    new Chromosome("chrUn_KN150112v1", 3423),
    new Chromosome("chrUn_KN149845v1", 3367),
    new Chromosome("chrUn_KN150673v1", 3357),
    new Chromosome("chrUn_KN150253v1", 3149),
    new Chromosome("chrUn_KN150321v1", 3079),
    new Chromosome("chrUn_KN150650v1", 3012),
    new Chromosome("chrUn_KN149776v1", 2919),
    new Chromosome("chrUn_KN150037v1", 2866),
    new Chromosome("chrUn_KN150612v1", 2865),
    new Chromosome("chrUn_KN149833v1", 2778),
    new Chromosome("chrUn_KN149742v1", 2671),
    new Chromosome("chrUn_KN150205v1", 2620),
    new Chromosome("chrUn_KN150318v1", 2580),
    new Chromosome("chrUn_KN149822v1", 2460),
    new Chromosome("chrUn_KN149824v1", 2357),
    new Chromosome("chrUn_KN150543v1", 2343),
    new Chromosome("chrUn_KN150231v1", 2322),
    new Chromosome("chrUn_KN150535v1", 2315),
    new Chromosome("chrUn_KN150560v1", 2301),
    new Chromosome("chrUn_KN150417v1", 2254),
    new Chromosome("chrUn_KN150233v1", 2246),
    new Chromosome("chrUn_KN150693v1", 2190),
    new Chromosome("chrUn_KN150027v1", 2148),
    new Chromosome("chrUn_KN149726v1", 2146),
    new Chromosome("chrUn_KN150597v1", 2137),
    new Chromosome("chrUn_KN150648v1", 2077),
    new Chromosome("chrUn_KN150206v1", 2052),
    new Chromosome("chrUn_KN149975v1", 2035),
    new Chromosome("chrUn_KN150470v1", 2027),
    new Chromosome("chrUn_KN149809v1", 2001),
    new Chromosome("chrUn_KN150051v1", 1995),
    new Chromosome("chrUn_KN149798v1", 1990),
    new Chromosome("chrUn_KN150277v1", 1954),
    new Chromosome("chrUn_KN149954v1", 1953),
    new Chromosome("chrUn_KN150034v1", 1919),
    new Chromosome("chrUn_KN150192v1", 1918),
    new Chromosome("chrUn_KN150583v1", 1918),
    new Chromosome("chrUn_KN150688v1", 1917),
    new Chromosome("chrUn_KN149956v1", 1889),
    new Chromosome("chrUn_KN150180v1", 1872),
    new Chromosome("chrUn_KN150503v1", 1834),
    new Chromosome("chrUn_KN150515v1", 1813),
    new Chromosome("chrUn_KN150465v1", 1765),
    new Chromosome("chrUn_KN150026v1", 1755),
    new Chromosome("chrUn_KN149786v1", 1745),
    new Chromosome("chrUn_KN150237v1", 1732),
    new Chromosome("chrUn_KN150409v1", 1729),
    new Chromosome("chrUn_KN150024v1", 1714),
    new Chromosome("chrUn_KN150611v1", 1697),
    new Chromosome("chrUn_KN149736v1", 1649),
    new Chromosome("chrUn_KN150086v1", 1639),
    new Chromosome("chrUn_KN149886v1", 1633),
    new Chromosome("chrUn_KN150294v1", 1627),
    new Chromosome("chrUn_KN149785v1", 1577),
    new Chromosome("chrUn_KN149777v1", 1553),
    new Chromosome("chrUn_KN150153v1", 1545),
    new Chromosome("chrUn_KN149867v1", 1514),
    new Chromosome("chrUn_KN150354v1", 1452),
    new Chromosome("chrUn_KN150480v1", 1422),
    new Chromosome("chrUn_KN149972v1", 1358),
    new Chromosome("chrUn_KN149985v1", 1354),
    new Chromosome("chrUn_KN149885v1", 1347),
    new Chromosome("chrUn_KN150370v1", 1323),
    new Chromosome("chrUn_KN150298v1", 1322),
    new Chromosome("chrUn_KN149773v1", 1302),
    new Chromosome("chrUn_KN150473v1", 1285),
    new Chromosome("chrUn_KN149820v1", 1281),
    new Chromosome("chrUn_KN149740v1", 1265),
    new Chromosome("chrUn_KN150437v1", 1262),
    new Chromosome("chrUn_KN150229v1", 1251),
    new Chromosome("chrUn_KN150320v1", 1241),
    new Chromosome("chrUn_KN150215v1", 1237),
    new Chromosome("chrUn_KN150704v1", 1233),
    new Chromosome("chrUn_KN150533v1", 1222),
    new Chromosome("chrUn_KN150621v1", 1204),
    new Chromosome("chrUn_KN150544v1", 1198),
    new Chromosome("chrUn_KN150440v1", 1193),
    new Chromosome("chrUn_KN150356v1", 1177),
    new Chromosome("chrUn_KN149873v1", 1146),
    new Chromosome("chrUn_KN150119v1", 1143),
    new Chromosome("chrUn_KN150338v1", 1142),
    new Chromosome("chrUn_KN150223v1", 1141),
    new Chromosome("chrUn_KN149994v1", 1137),
    new Chromosome("chrUn_KN150701v1", 1133),
    new Chromosome("chrUn_KN150623v1", 1126),
    new Chromosome("chrUn_KN149712v1", 1115),
    new Chromosome("chrUn_KN150367v1", 1114),
    new Chromosome("chrUn_KN149957v1", 1094),
    new Chromosome("chrUn_KN150163v1", 1082),
    new Chromosome("chrUn_KN150457v1", 1076),
    new Chromosome("chrUn_KN150018v1", 1063),
    new Chromosome("chrUn_KN150216v1", 1020),
    new Chromosome("chrUn_KN150481v1", 1008),
    new Chromosome("chrUn_KN150657v1", 1007),
    new Chromosome("chrUn_KN150461v1", 1000),
    new Chromosome("chrUn_KN150247v1", 728),
    new Chromosome("chrUn_KN150525v1", 650),
];

export default SCAFFOLDS;
